import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "fields"];

  toggle() {
    if (this.checkboxTarget.checked) {
      this.fieldsTarget.style.display = "";
    } else {
      this.fieldsTarget.style.display = "none";
    }
  }
}
